import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVerticalDoubleCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20.603 10.892 9.55 21.943l-6.153-6.152 1.892-1.89 4.26 4.26L18.712 9zm0-7L9.55 14.943 3.397 8.791l1.892-1.89 4.26 4.26L18.712 2z" })
});
export default SvgVerticalDoubleCheck;
